import React from "react";
import styles from "../Modules/Projects.module.css";
import { ProjectCard } from "../imports";

class Projects extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showAcademic: false };
  }

  render() {
    const { projectsData } = this.props;
    const { showAcademic } = this.state;

    const pythonFocusedProjects = projectsData.filter(project =>
      project.technologies.includes("Python")
    );
    const academicEarlyWorkProjects = projectsData.filter(project =>
      !project.technologies.includes("Python")
    );

    return (
      <div id="projects" className={styles.projects}>
        <div className={styles.heading}>
          <span className={styles.eyebrow}>Portfolio</span>
          <h2>Projects</h2>
        </div>

        <div className={styles.cards}>
          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>Python Focused</h3>
            <div className={styles.sectionCards}>
              {pythonFocusedProjects.map((project) => (
                <ProjectCard
                  key={project.id}
                  name={project.name}
                  projectTechnologies={project.technologies}
                  description={project.description}
                  previewImage={project.previewImage}
                  demo={project.demo}
                  demoVideo={project.demoVideo}
                  gitRepo={project.gitRepo}
                  viewCode={project.viewCode}
                  imgAlt={project.imgAlt}
                  projectInfoPath={project.projectInfoPath}
                />
              ))}
            </div>
          </div>

          {academicEarlyWorkProjects.length > 0 && (
            <>
              <button
                className={styles.toggleButton}
                onClick={() => this.setState({ showAcademic: !showAcademic })}
              >
                {showAcademic ? "Hide older projects ↑" : `Also: Academic & Early Work (${academicEarlyWorkProjects.length}) ↓`}
              </button>

              {showAcademic && (
                <div className={styles.section}>
                  <h3 className={styles.sectionTitle}>Academic / Early Work</h3>
                  <div className={styles.sectionCards}>
                    {academicEarlyWorkProjects.map((project) => (
                      <ProjectCard
                        key={project.id}
                        name={project.name}
                        projectTechnologies={project.technologies}
                        description={project.description}
                        previewImage={project.previewImage}
                        demo={project.demo}
                        demoVideo={project.demoVideo}
                        gitRepo={project.gitRepo}
                        viewCode={project.viewCode}
                        imgAlt={project.imgAlt}
                        projectInfoPath={project.projectInfoPath}
                      />
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    );
  }
}

export default Projects;
